export default __webpack_public_path__ + "static/media/3.40aae8a4.png";